<template>
  <ModalAlert
    :text-body="modalTextBody"
    :open="modalShow"
    :type="modalType"
    :showModalClose="false"
    :showCustomButtons="false"
    @close="clearModalAlertData"
  />
</template>

<script>
import ModalAlert from '@/components/modals/ModalAlert.vue'

export default {
  name: '',

  components: {
    ModalAlert
  },

  methods: {
    clearModalAlertData () {
      this.$emit('clearModalAlertData')
    }
  },

  props: {
    modalAlert: Object
  },

  computed: {
    modalShow () {
      return this.modalAlert ? this.modalAlert.show : null
    },

    modalType () {
      const options = this.modalAlert ? this.modalAlert.options : null

      return options ? options.type : ''
    },

    modalTextBody () {
      const options = this.modalAlert ? this.modalAlert.options : null

      return options ? this.$tr(options.bodyKey) : ''
    }
  }
}
</script>
